/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from '@/config'
import HttpProvider from '@/services/HttpProvider'
import Blog from '@/services/Blog'
import find from 'lodash/find'
import { EventBus } from '@/helpers'
import { restWithCache } from '@/store/lib/search'
import { encodeScriptTag } from '@/helpers/utils'

const cache = {}
const storeViewCodeRegex = /(({)+(storeViewCode)(})+)|(store_view_code)/g

function restOrCache (indentifier, query, storeViewCode) {
  query = query.replace('{{indentifier}}', indentifier)
  const id = `${indentifier}-${storeViewCode}`
  if (cache[id] && process.client) {
    return Promise.resolve(cache[id])
  } else {
    return restWithCache({
      query,
      restPromise: HttpProvider.get(query, {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
    })
      .then(data => {
        cache[id] = data
        return data
      })
  }
}

export default {
  init (ctx) {
    let ssrIDS = ctx.state.ssrIDS
    ssrIDS.forEach(id => {
      EventBus.$emit('cms:update', { id })
    })
  },
  getPage ({ commit, rootGetters, rootState }, req) {
    let pageId = req
    let url = Config.API.cms.page
      .replace('{{storeViewCode}}', rootState.ui.storeViewCode)
      .replace('{{storeviewID}}', rootGetters['storeConfig/storeviewID'])
    if (typeof req === 'object') {
      pageId = req.id
      url = Config.API.cms.pageId
        .replace('{{storeViewCode}}', rootState.ui.storeViewCode)
        .replace('{{storeviewID}}', rootGetters['storeConfig/storeviewID'])
        .replace('{{pageID}}', pageId)
    }
    return restOrCache(pageId, url, rootState.ui.storeViewCode)
      .then(data => {
        let objHtml = {}
        let meta = {}
        if (data && data.active) {
          const pageData = data
          meta.title = pageData.meta_title || pageData.title
          meta.abstract = undefined
          meta.description = pageData.meta_description ? pageData.meta_description : undefined
          meta.keywords = pageData.meta_keywords ? pageData.meta_keywords : undefined
          meta.head_content_page = pageData.head_content_page ? pageData.head_content_page : undefined
          meta.meta_robots = pageData.meta_robots ? pageData.meta_robots : undefined
          objHtml.meta = meta
          objHtml.content = pageData.content.replace(storeViewCodeRegex, rootState.ui.codeLang)
          commit('setPage', objHtml)
          if (!process.client) {
            commit('setSsrIDS', 'generic-page')
          }
        } else {
          throw new Error('page not found')
        }
        return pageId
      }).catch((error) => {
        commit('setPage', { content: '' })
        throw error
      })
  },
  loadContents ({ commit, dispatch }, contentIDs) {
    return Promise.all(contentIDs.map((contentID) => {
      return dispatch('loadContent', contentID)
    }))
  },
  loadContent ({ commit, rootGetters, rootState }, contentID) {
    // return Promise.resolve(cmsMock).then(response => {
    return restOrCache(contentID, Config.API.cms.content
      .replace('{{storeViewCode}}', rootState.ui.storeViewCode)
      .replace('{{storeviewID}}', rootGetters['storeConfig/storeviewID']), rootState.ui.storeViewCode)
      .then(data => {
        if (data && data.active) {
          // data.content = data.content.replace(/({)+(storeViewCode)(})+/g, rootState.ui.codeLang)
          data.content = data.content.replace(storeViewCodeRegex, rootState.ui.codeLang)
          // commit('setContent', { contentID, 'data': data.content.replace(/({)+(storeViewCode)(})+/g, rootState.ui.storeViewCode) })
          commit('setContent', { contentID, data })
        }
        if (!process.client) {
          commit('setSsrIDS', contentID)
        }
        return contentID
      }).catch((error) => {
        console.error(`ERROR LOAD ${contentID} :=> ${error.message}`)
      })
  },
  global (ctx) {
    return ctx.dispatch('loadContents', Config.API.cms.globalIDs)
  },
  getBlog ({ commit, rootState }, slug) {
    let category = find(rootState.category.flatted, { url_path: slug })
    var promise
    if (category) {
      promise = Blog.getCategory(category, rootState.user.token, rootState.ui.storeViewCode)
    } else {
      promise = Blog.getPost(slug, rootState.user.token, rootState.ui.storeViewCode)
    }
    return promise.then(_pageData => {
      let pageData = JSON.parse(JSON.stringify(_pageData))
      var meta = {}
      var objHtml = {}
      meta.title = pageData.meta_title ? pageData.meta_title : undefined
      meta.description = pageData.meta_description ? pageData.meta_description : undefined
      /* meta.abstract = undefined
      meta.keywords = pageData.meta_keywords ? pageData.meta_keywords : undefined */
      objHtml.meta = meta
      let content = pageData.filtered_content_ext
      if (pageData.filtered_short_content_ext) {
        pageData.filtered_short_content_ext = encodeScriptTag(pageData.filtered_short_content_ext)
      }
      objHtml.content = content ? content.replace(storeViewCodeRegex, rootState.ui.storeViewCode) : content
      if (!category) {
        delete pageData.filtered_content_ext
        commit('blogCurrPost', pageData)
      }
      commit('setPage', objHtml)
    })
  }
}
